/**
 * The DOM id of one option, so a `combobox` input can name the active row in
 * `aria-activedescendant`.
 *
 * Exported because the input needs to compute the SAME id for the row it has
 * highlighted, and a screen reader announces nothing at all if the two disagree
 * — a failure that is invisible on screen.
 */
export function searchOptionId(listId: string, rowKey: string): string {
  return `${listId}-${rowKey.replace(/[^a-zA-Z0-9_-]/g, '_')}`;
}
